"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./ProgressBar.css");

var _Colors = _interopRequireDefault(require("../../Basic/Colors/Colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @visibleName Progress Bar
 */
function ProgressBar(_ref) {
  var percent = _ref.percent,
      color = _ref.color,
      width = _ref.width,
      className = _ref.className;
  var styles = {
    progress: {
      width: width,
      backgroundColor: _Colors.default.withOpacity(color || _Colors.default.sinineVaal, 0.2)
    },
    progressBar: {
      width: "".concat(percent, "%"),
      backgroundColor: color || _Colors.default.sinineVaal
    }
  };

  if (percent < 0) {
    styles.width = '0';
  } else if (percent > 100) {
    styles.width = '100%';
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "progress ".concat(className || ''),
    style: styles.progress
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "progress-bar",
    style: styles.progressBar
  }));
}

ProgressBar.propTypes = {
  /** Progress Bar percentage */
  percent: _propTypes.default.number,

  /** Progress Bar width */
  width: _propTypes.default.string
};
ProgressBar.defaultProps = {
  percent: 0,
  width: '100%'
};
var _default = ProgressBar;
exports.default = _default;